'use strict';

angular.module('mean.inspinia').factory('Inspinia', [
  function() {
    return {
      name: 'inspinia'
    };
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/inspinia/public/services/inspinia.js